import React, { Component } from 'react';


import { DateRange, DateRangePicker, Calendar } from 'react-date-range';

//import {es} from 'date-fns/locale';
//import { es } from 'react-date-range/src/locale/index.js'
import { addDays, addMonths } from 'date-fns';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

// Shared components
import Portlet from './Portletcomponents/Portlet';
import PortletHeader from './Portletcomponents/PortletHeader';
import { CSVLink } from "react-csv";
import PortletFooter from './Portletcomponents/PortletFooter';
import Typography from '@material-ui/core/Typography';
import moment from 'moment'
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Popover from '@material-ui/core/Popover';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import {getObjectiveSpecial} from '../../../services/getObjectiveSpecial'
import 'moment/locale/es'
moment.locale('es')
import Movistar from './Movistar'
import Header from './Movistar/Header'
import Control from './Control'
import PortletContent from './Portletcomponents/PortletContent';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
let params = new URLSearchParams(location.search);
var objective = params.get('objectiveId');
var user = 6829
var token = params.get('token')


class Content extends Component {
  constructor(props) {
    //console.log(moment().subtract(1, "weeks")._d)
    super(props)
    this.handleInfo = this.handleInfo.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.setObjective = this.setObjective.bind(this);
    this.state = {
      
      objective:objective,
      user: user,
      token: token,
      error:false,
      logError:"",
      isLoading:true,
      listObjectives:[],
      listSla:[{'id':0, 'tiempo':'15 segs.'},{'id':1,'tiempo':'10 segs.'},{'id':2,'tiempo':'6 segs.'}],
      showObjective:null,
      namePeriodPorlet:["Última semana","Mes Actual", "Custom"],
      period:0,
      periodEl:null,
      open:false,
      anchorEl:null,
      range: {},
      dateRange: {
        selection: {
            startDate: moment().subtract(1, "weeks")._d,
            endDate: moment()._d,
            key: 'selection',
        },
      },
      toggleCustom:false,
      errorDate:false,
      dataScv:[],
      showCsv:null,
      control:false,
      dayGlobals:[],
      monthHistoric:[]
    }
    
  }

  setObjective=(value)=>{
    const {showObjective}=this.state
    //console.log('callset', value.objetivo_id, showObjective.objetivo_id)
    if(value.objetivo_id!==showObjective.objetivo_id||showObjective.paso!==value.paso){
      //console.log('change show')
      this.setState({
        showObjective:value,
        objective:value.objetivo_id
      })
    }
  }

  handleBack=()=> {
    this.setState({
      control:false
    })
  }

  handleInfo(info, extra) {
    //console.log('content info', info)
    var headers=[{ label: "Kpi's", key: "kpi" },]
    var dataDict={}
    var dataParcial={}
    var dataError={}
    var dataPromedio={}
    var dataModificado={}

    dataDict["kpi"]="Perf 15 seg."
    dataParcial["kpi"]="Fuera de Sla"
    dataError["kpi"]="Indisponibilidad/Error"
    dataPromedio["kpi"]="Tiempo de Respuesta"
    
    info.historico.map(mes=>{
      var nombre_mes=Object.keys(mes)[0]
      var valores=Object.values(mes)[0][0]
      headers.push({ label: Object.keys(mes)[0] , key: nombre_mes},)
      dataDict[nombre_mes]=valores.perf_ok
      dataParcial[nombre_mes]=valores.perf_parcial
      dataError[nombre_mes]=valores.perf_error
      dataPromedio[nombre_mes]=valores.promedio
      dataModificado = valores.modificado
    })
    if(Object.keys(extra).length!==0){
      headers.push({label: extra.mes , key: extra.mes})
      dataDict[extra.mes]=extra.perf
      dataParcial[extra.mes]=extra.parcial
      dataError[extra.mes]=extra.error
      dataPromedio[extra.mes]=extra.promedio
    }
    //console.log(headers)
    
    info.globales.map(global=>{
      
      headers.push({ label: global.dia, key: global.dia },)
      dataDict[global.dia]=global.performance_global
      dataParcial[global.dia]=global.parcial_global
      dataError[global.dia]=global.error_global
      dataPromedio[global.dia]=global.promedio_global
    })
    var data=[dataDict,dataParcial,dataError, dataPromedio]
    this.setState({
      showCsv:true,
      headers: headers,
      data:data,
      dayGlobals:info.globales,
      fileName:info.nombre_objetivo+".csv",
      step:info.paso,
      sla_p:info.sla_performance,
      monthHistoric :info.historico
    })
  }
  componentDidMount=()=>{
    //console.log('mount')
    this.validObjective()
  }

  componentDidUpdate(prevProps, prevState) {
      if(this.state.isLoading===true){
        //console.log('upd')
          this.validObjective();
      }
  }

  changeSla = (event, value) => {
    const {showObjective}=this.state
    //console.log(value.tiempo.substring(0,2))
    //console.log(showObjective.sla_performance)
    if(value!==null && showObjective.sla_performance!==value.tiempo.substring(0,2)){
      
      showObjective.sla_performance=value.tiempo.substring(0,2)
      //console.log(shown)
      this.setState({
        showObjective:showObjective,
        showCsv:null
      })
    }
  };

  //CALL SERVICE VALID OBJECTIVE AND TOKEN
  validObjective=()=>{
    const {objective, user, token}=this.state
    try{
      getObjectiveSpecial(objective, user, token).then( data => {
        //console.log(data)
        if(data.error){
          this.setState({
            error:true,
            logError:data.error,
            isLoading:false
          })
        }else{
          //console.log(data.objectives)
          this.setState({
            listObjectives:data.objectives,
            showObjective:data.objectives[0],
            isLoading:false
          })
        }
      })
    }catch(e){
      this.setState({
        error:true,
        logError:"Error de Conexión",
        isLoading:false
      })
    }
  }
  handleShowPeriod = event => {
    this.setState({
        periodEl: event.currentTarget
    });
  };
  handleClosePeriod = () => {
    this.setState({
        periodEl: null
    });
  };

  onOpenModal = (event) => {
    this.setState({
      anchorEl:event.currentTarget,
      open: true,
      range: {}
    });
  };
  LastMonth = (event) => {

    /* const {dateRange}= this.state;
    console.log(dateRange.selection.startDate, dateRange.selection.endDate); */
    this.setState({
      periodEl: null,
      range: {},
      dateRange: {
          selection: {
              startDate: moment().startOf('month')._d,
              endDate: moment()._d,
              key: 'selection',
          },
      },
      period:0, 
      toggleCustom:!this.state.toggleCustom
    });
  };
  LastWeek = (event) => {
    /* const {dateRange}= this.state;
    console.log(dateRange.selection.startDate, dateRange.selection.endDate); */
    this.setState({
      periodEl: null,
      range: {},
      dateRange: {
          selection: {
              startDate: moment().subtract(1, "weeks")._d,
              endDate: moment()._d,
              key: 'selection',
          },
      },
      period:1, 
      toggleCustom:!this.state.toggleCustom
    });
  };
  

  onCloseModal = () => {
    this.setState({ open: false });
  };

  onCloseModalButton = () => {
    const {range, dateRange}=this.state
    var begin=dateRange.selection.startDate
    var end= dateRange.selection.endDate
    if(end-begin>2678400000){
      this.setState({ open:true, errorDate:true });
    }else{
      this.setState({ open: false,errorDate:false ,periodEl: null,period:2, toggleCustom:!this.state.toggleCustom, showCsv:null});
    }
    //this.setState({ open: false });
  };
  handleRangeChange(which, payload) {
    //console.log(payload.selection.startDate)
    //console.log(payload.selection.endDate)
    this.setState({
        [which]: {
            ...this.state[which],
            ...payload,
        },
    });
  }

  handleControl=()=>{
    this.setState({
      control:true
    });
  }

  render() {
    const {error, logError, isLoading, listObjectives, user, showObjective, namePeriodPorlet, period, periodEl, open,anchorEl, 
      errorDate, dateRange, toggleCustom,showCsv, data,headers, fileName, control, listSla}=this.state
    
    // indexList, listObjectives[indexList])
    const showPeriodEl = Boolean(periodEl);
    if(isLoading){
      return (
         <Portlet>
          <PortletContent>
          <Typography>
            cargando...
          </Typography>
          </PortletContent>
        </Portlet>
      )
    }else{
      if(error===true){
        return (
          <Portlet>
            <PortletContent>
              <Typography>
                {logError}
              </Typography>
            </PortletContent>
          </Portlet>
        )
      }else if(control===true){
        return(
          <Portlet>
            <PortletContent>
              <Typography>
                <Control infoControl={this.handleBack} data={this.state}/>
              </Typography>
            </PortletContent>
          </Portlet>
        )
      }else{
        //console.log('renderc', showObjective.nombre)
        return (
          <Portlet style={{paddingTop:"105px"}}>
            <PortletHeader style={{height:"0px"}}>
              <Grid
                container
                spacing={1}
              >
                <Header objectives={listObjectives} setObjective={this.setObjective}/>
                
                <Grid
                  item
                  xs={2}
                  sm={2}
                  md={2}
                  xl={2}
                  style={{textAlign:"right"}}  
                >
                  <Grid
                    container
                    spacing={1}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      xl={12}
                      style={{textAlign:"right"}}  
                    >
                      {showCsv?
                        <Button onClick={this.handleControl}>
                          <Typography style={{fontSize:"0.75rem"}} variant="h6">  Control Operador</Typography>
                        </Button>
                        :null
                        }
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      xl={12}
                      style={{textAlign:"right"}}  
                    >
                        <Button  style={{fontSize:'12px',float:'right', color:'#66788A'}} onClick={this.handleShowPeriod} >
                          {namePeriodPorlet[period]}<ArrowDropDownIcon />
                        </Button>
                        <Popover
                          anchorEl={periodEl}
                          anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'center'
                          }}
                          onClose={this.handleClosePeriod}
                          open={showPeriodEl}
                          transformOrigin={{
                              vertical: 'top',
                              horizontal: 'center'
                          }}>
                          <List>
                            <ListItem>
                              <Button className="button muted-button" onClick={this.LastWeek}>Última Semana</Button>
                            </ListItem>
                            <ListItem>
                              <Button className="button muted-button" onClick={this.LastMonth}>Mes Actual</Button>
                            </ListItem>
                            <ListItem>
                              <Button className="button muted-button" onClick={this.onOpenModal}>Custom</Button>
                            </ListItem>
                            <Popover open={open} 
                              onClose={this.onCloseModal}
                              anchorEl={anchorEl}
                              anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                              transformOrigin={{vertical: 'top', horizontal: 'center' }}
                              >
                                <Grid
                                  container
                                  spacing={1}
                                >
                                  
                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}
                                  >
                                    <DateRange
                                      maxDate={addDays(new Date(), 0)}
                                      minDate={addMonths(new Date(), -2)}
                                      //locale={es}
                                      onChange={this.handleRangeChange.bind(this, 'dateRange')}
                                      moveRangeOnFirstSelection={false}
                                      ranges={[this.state.dateRange.selection]}
                                      className={'PreviewArea'}
                                    />
                                  </Grid>
                                </Grid>
                                <Grid>
                                  {errorDate?
                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}
                                  >
                                    <Typography variant="h6" style={{color:"red"}}>Seleccione fecha menor a un mes</Typography>
                                  </Grid>:null}
                                  <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    xl={12}
                                  >
                                    <Button onClick={this.onCloseModalButton}>Generar</Button>
                                  </Grid>
                                </Grid>
                                
                                
                            </Popover>
                          </List>
                        </Popover>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </PortletHeader>
            <PortletContent style={{paddingTop:"120px"}}>
                
              <Movistar objective={showObjective} user={user} period={dateRange.selection} toggleCustom={toggleCustom} infoData={this.handleInfo}/>
            </PortletContent>
              
            <PortletFooter >
              <Grid
                container
                spacing={2}
              >
                
                {showCsv?
                  <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  xl={12}
                  style={{textAlign:"right"}}
                  >
                    <Button>
                      <CSVLink data={data} headers={headers} filename={fileName} style={{textDecoration:"none"}}>
                        <Typography variant="button">
                          Descarga Csv
                        </Typography>
                      </CSVLink>
                    </Button>
                  </Grid>
                :null
                }
                
              </Grid>
                
            </PortletFooter>
          </Portlet>
        )
      }
    }
    
  }
}


export {Content}


// WEBPACK FOOTER //
// ./src/layouts/components/content/index.jsx